  const scaleFunction = () => {
      if(clientWidht < 767){
          //放大镜效果
        // scal_img_src
       const mainImg = document.getElementById('main-img');
        mainImg.addEventListener('click', function(e) {
          document.getElementsByClassName('scal_maske')[0].style.cssText += 'display:block'
          document.getElementById('scal_img_src').src = e.target.getAttribute('src')
        })
        document.getElementsByClassName('close_svg')[0].addEventListener('click', function(e) {
          document.getElementsByClassName('scal_maske')[0].style.cssText += 'display:none'
        })
        return 
      }
      //放大镜效果
        const container = document.querySelector('.detail_container');
        const magnifier = document.querySelector('.magnifier');
        const mainImg = document.getElementById('main-img');
        
        // 配置参数
        const scalConfig = {
            zoomLevel: 3,    // 放大倍数
            magnifierSize: 350 // 放大镜尺寸
        }

        // 等待图片加载完成
        mainImg.onload = function() {
            // 设置放大镜背景（使用同一图片源）
            magnifier.style.backgroundImage = `url(${this.src})`;
            
            // 计算实际图片显示尺寸
            const imgWidth = this.naturalWidth;
            const imgHeight = this.naturalHeight;
            
            // 设置容器尺寸与图片显示尺寸一致
            container.style.width = `${this.width}px`;
            container.style.height = `${this.height}px`;

            // 鼠标移动处理
            container.addEventListener('mousemove', (e) => {
                const rect = container.getBoundingClientRect();
                
                // 计算鼠标相对位置百分比
                let x = e.clientX - rect.left;
                let y = e.clientY - rect.top;

                // 边界限制
                x = Math.max(0, Math.min(x, rect.width));
                y = Math.max(0, Math.min(y, rect.height));

                // 更新放大镜位置
                magnifier.style.left = `${x - scalConfig.magnifierSize/2.5}px`;
                magnifier.style.top = `${y - scalConfig.magnifierSize/2.5}px`;

                // 正确计算背景位置
                const bgX = (x * scalConfig.zoomLevel - scalConfig.magnifierSize/2.5);
                const bgY = (y * scalConfig.zoomLevel - scalConfig.magnifierSize/2.5);
                
                magnifier.style.backgroundPosition = `-${bgX}px -${bgY}px`;
            });

            // 显示/隐藏控制
            container.addEventListener('mouseenter', () => {
                magnifier.style.display = 'block';
            });

            container.addEventListener('mouseleave', () => {
                magnifier.style.display = 'none';
            });
        }
  }